<template>
  <div class="main_bg4">
      <div style="padding-top:100px;" v-if="!row">
          <v-progress-circular
        :size="70"
        :width="7"
        color="red"
        indeterminate
        ></v-progress-circular>
      </div>
    <v-container style="padding-top:80px;max-width:400px;" v-if="row">
        <v-row>
            <v-col cols="12"><img src="../assets/head_car_list.svg" width="100%"></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-card :color="(row.spinRewardId !== '') ? '#E5E4E5' : '#FFFFFF'">

                    <v-card-text style="text-align:left;font-family:Kanit">
                        <v-row>
                            <v-col cols="6">
                                <div :class="(row.spinRewardId !== '') ? 'text_service_head_off' : 'text_service_head_on'">
                                    <img src="../assets/ico_service_off.svg" width="22" style="margin-right:2px;" v-if="row.service === 'Service'"> 
                                    <img src="../assets/ico_service_off.svg" width="22" style="margin-right:2px;" v-if="row.service === 'Sale'"> 
                                    <img src="../assets/ico_insurance_off.svg" width="22" style="margin-right:2px;" v-if="row.service === 'Insurance'"> 
                                    {{row.service.toUpperCase()}}
                                </div>
                                <span v-if="row.service === 'Service'">
                                    เลขทะเบียน<br><h2>{{row.licenseNo}}</h2><br>
                                    ประเภทบริการ<br><h2>{{row.serviceType}}</h2>
                                </span>
                                <span v-if="row.service === 'Sale'">
                                    รุ่นรถที่สนใจ<br><h2>{{row.carModel}}</h2>
                                </span>
                                 <span v-if="row.service === 'Insurance'">
                                    บริษัทประกัน<br><h2>{{row.insurance}}</h2><br>
                                    ประเภท: <h2>{{row.insuranceType}}</h2>
                                </span>
                                <div v-if="row.spinRewardId !== ''"><br>
                                    <div v-for="reward in rewardList.filter((temp) => { return row.spinRewardId === temp.id })" v-bind:key="row.id + '_' +reward.id">
                                        <img src="../assets/ico_gift.svg" width="20" style="margin-right:8px;"> <b>{{reward.description}}</b>
                                        <span v-if="row.bookingDate"><br><span v-if="row.service === 'Service'">วันที่นัด : {{row.bookingDate}}<br></span>สาขา : {{row.branch}}</span>
                                        <span v-if="row.confirm === 0" style="color:red"><br>หมายเหตุ: สละสิทธิ์</span>
                                        <span v-if="row.confirm === '-1'" style="color:red"><br>หมายเหตุ: สละสิทธิ์</span>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <img src="../assets/illus_gift.svg" width="100%" v-if="row.spinRewardId !== ''">
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import axios from 'axios'
// @ is an alias to /src
export default {
  name: 'Result',
  data() {
    return {
      pictureUrl: null,
      displayName: null,
      gameData: null,
      profile: null,
      row: null,
      rewardList: []
    }
  },
  mounted () {
    this.$liff
        .init({
        liffId: this.$liffId_VGroup
        })
        .then(async() => {
        if (!this.$liff.isLoggedIn()) {
            this.$liff.login({redirectUri: window.location.href});
        } else {
            await this.getUserProfile()
            await this.getRewardList()
            await this.getRegister()
        }
        })
        .catch((err) => {
        // Error happens during initialization
        console.log(err.code, err.message);
        });
  },
  methods: {
    async getRewardList () {
        await axios({
            method: "GET",
            url: `${this.$apiUrl}getRewardAll`,
        }).then((response) => {
            this.rewardList = response.data
        })
    },
    async getRegister() {
        await axios({
            method: "GET",
            url: `${this.$apiUrl}getRegister`,
            params: { userId: this.profile.userId }
        }).then((response) => {
            console.log(response.data)
            if(response.data === '') {
                this.$router.push('register')
            }
            this.row = response.data
        })
    },
    async getUserProfile() {
        this.profile = await this.$liff.getProfile()
        this.pictureUrl = this.profile.pictureUrl
        this.displayName = this.profile.displayName
    }
  }
}
</script>
<style scoped>
#wheelFrame {
    background: url('../assets/spinbg.png');
    height: 100%;
    position: absolute;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    top: 0px;
    left: 0px;
    z-index: 0;
}
.wheelContainer {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    left: 30px;
    top: 0px;
    z-index: 1000;
    position: absolute;
    width: 340px;
    height: 340px;
}
</style>